import { useState } from "react";

import { Input } from "@components/ui-kit/Input";
import { Select } from "@components/ui-kit/Select";
import { Plus, Search } from "lucide-react";
import { PurchaseFormData } from "../../forms/PurchaseForm";
import { EMPTY_PURCHASE } from "../../forms/utils";
import AddPurchaseModal from "../../modals/PurchaseModals/AddPurchaseModal";
import EditPurchaseModal from "../../modals/PurchaseModals/EditPurchaseModal";
import styles from "../styles.module.scss";
import PurchaseTable from "./PurchaseTable";
import { purchaseData, PurchaseRow } from "./utils";
import { UploadCSVModal } from "../../modals/UploadCSVModal";

export const PurchaseTab: React.FC = () => {
  const [openAdd, setOpenAdd] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [selectedPurchase, setSelectedPurchase] = useState<PurchaseRow | null>(
    null,
  );
  const [search, setSearch] = useState("");
  const [filterStatus, setFilterStatus] = useState<string>("All");
  const data = [EMPTY_PURCHASE];

  const filterData = (data: PurchaseRow[]) => {
    return data.filter((item) => {
      return (
        item.poNumber
          .toLowerCase()
          .trim()
          .includes(search.toLowerCase().trim()) &&
        (filterStatus === "All" || item.status === filterStatus.trim())
      );
    });
  };

  const handleSavePurchases = (upd: PurchaseFormData[]) => {
    console.log(upd);
  };

  const handleSavePurchase = (upd: PurchaseFormData, idx: number) => {
    console.log(upd);
    setOpenEdit(false);
  };

  const handleEdit = (purchase: PurchaseRow) => {
    setSelectedPurchase(purchase);
    setOpenEdit(true);
  };

  const handleDelete = (purchase: PurchaseRow) => {
    console.log("Delete purchase", purchase);
  };

  return (
    <div className={styles.suppliers}>
      <div className={styles.toolbar}>
        <Input
          value={search}
          icon={<Search />}
          onChange={setSearch}
          className={styles.searchInput}
          placeholder="Search SO number"
        />

        <div className={styles.actions}>
          <Select
            value={filterStatus}
            onChange={(val: string) => setFilterStatus(val)}
            className={styles.filter}
            placeholder="Filter by status"
            options={[
              { id: "All", text: "All" },
              { id: "Open", text: "Open" },
              { id: "Cancelled", text: "Cancelled" },
              { id: "Ongoing", text: "Ongoing" },
            ]}
          />
        </div>
        <button className={styles.blueButton} onClick={() => setOpenAdd(true)}>
          <Plus width={16} height={16} stroke="#fff" fontWeight={"bold"} />
          add purchase order
        </button>
      </div>

      <PurchaseTable
        data={filterData(purchaseData)}
        onDelete={handleDelete}
        onEdit={handleEdit}
      />

      <UploadCSVModal
        open={openAdd}
        onCancel={() => setOpenAdd(false)}
        title="Upload Purchase Orders"
        ManualModal={AddPurchaseModal}
        EditModal={EditPurchaseModal}
        onSaveData={handleSavePurchases}
        data={data}
      />

      <EditPurchaseModal
        open={openEdit}
        onCancel={() => setOpenEdit(false)}
        title="Edit Shipment Order"
        data={[EMPTY_PURCHASE]}
        onSaveData={handleSavePurchase}
        index={0}
        onPrev={function (): void {
          throw new Error("Function not implemented.");
        }}
        onNext={function (): void {
          throw new Error("Function not implemented.");
        }}
        filename={""}
      />
    </div>
  );
};
